<template>
  <v-app>
    <v-app-bar color="primary" dark app>
      Content API
    </v-app-bar>
    <Content/>
  </v-app>
</template>

<script>

import Content from "./components/Content";

export default {
  name: 'App',

  components: {
    Content,
  },

  data: () => ({
    //
  }),
};
</script>
